module.exports = __webpack_public_path__ + "img/collection_log.4faa68f9.svg";